import { FC, memo } from 'react'
import { Box } from '@chakra-ui/react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
}

const SearchOutline = createIcon({
  displayName: 'SearchOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0 0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M14.1931 5.58187c2.33182 2.33182 2.33182 6.11245 0 8.44427 -2.33182 2.33182-6.11245 2.33182-8.44427 0 -2.33182-2.33182-2.33182-6.11245-1.77636e-15-8.44427 2.33182-2.33182 6.11245-2.33182 8.44427-1.77636e-15"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M14.15 14.06l5.85 5.93"
        ></path>
      </g>
    </>
  ),
})

const SearchTwoTone = createIcon({
  displayName: 'SearchTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0 0h24v24h-24Z"></path>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          fill="twoToneFillColor"
          d="M14.1931 5.58187c2.33182 2.33182 2.33182 6.11245 0 8.44427 -2.33182 2.33182-6.11245 2.33182-8.44427 0 -2.33182-2.33182-2.33182-6.11245-1.77636e-15-8.44427 2.33182-2.33182 6.11245-2.33182 8.44427-1.77636e-15"
        ></Box>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M14.15 14.06l5.85 5.93"
        ></Box>
      </g>
    </>
  ),
})

const Search: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
    case 'twoTone':
      return <CustomIcon as={SearchTwoTone} {...props} />
    default:
      return <CustomIcon as={SearchOutline} {...props} />
  }
}

export default memo(Search)
